import { render, staticRenderFns } from "./YoutubeChannel.vue?vue&type=template&id=ef4876fa&scoped=true&"
import script from "./YoutubeChannel.vue?vue&type=script&lang=js&"
export * from "./YoutubeChannel.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeChannel.vue?vue&type=style&index=0&id=ef4876fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4876fa",
  null
  
)

export default component.exports